import {PUSH_ATTACH_ID, REMOVE_ATTACH_ID} from '../actionType';

const initialState={requestFileId:''}
export default function (state=initialState,action){
  switch (action.type) {
    case PUSH_ATTACH_ID:
        return {
          ...state,
          requestFileId: action.requestFileId,
          requestType: action.type
        }
    case REMOVE_ATTACH_ID:
      return {
        ...state,
        requestFileId: action.requestFileId,
        requestType: action.type
      }
    default:
      return {
        requestFileId: '',
        requestType: ''
      };
  }
}
